import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Container, Col } from 'reactstrap';
import { AvFeedback, AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';

import { importMenuFromCSV } from '../../../actions';

class ImportMenuFromCSVScreen extends Component {
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    toggle() {
        this.props.onToggle();
    }

    onChange({ target }) {
        this.setState({ ...this.state, [target.name]: target.files[0] });
    }

    onSubmit(e) {
        e.preventDefault(); // Stop form submit
        this.props.importMenuFromCSV(this.props.restaurantId, this.state, this.props.resetMenuStylesOnPublishOrImport);
        this.toggle();
    }

    renderFileInput(fileType) {
        const { chooseFileInput } = styles;
        const fileName = `${fileType}File`;

        return (
            <AvGroup row>
                <Label for={fileName} sm={5}>{i18n.t(`screens:importMenuFromCSVScreen.${fileType}`)}</Label>
                <Col sm={7} style={chooseFileInput}>
                    <AvInput type="file" name={fileName} id={fileName} onChange={this.onChange} required={true} style={{overflow: 'hidden'}} />
                    <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                </Col>
            </AvGroup>
        );
    }

    render() {
        const { modalContainer, importBtnTxt } = styles;

        return (

            <Modal isOpen={this.props.isOpen} toggle={this.toggle}>
                <AvForm onValidSubmit={this.onSubmit}>
                    <ModalHeader className="modalHeader" toggle={this.toggle}>{i18n.t('screens:importMenuFromCSVScreen.importMenu')}</ModalHeader>
                    <ModalBody>
                        <Container style={modalContainer}>
                            {this.renderFileInput('items')}
                            {this.renderFileInput('modifiers')}
                            {this.renderFileInput('mealDeals')}
                            {this.renderFileInput('mealDealModifiers')}
                            {this.renderFileInput('taxes')}
                        </Container>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary">
                            <span className="menuIcons">
                                <span className="menuIcons"><MaterialIcon icon="cloud_download" color="#fff" size={19} /></span>
                                <span style={importBtnTxt} >{i18n.t('screens:menuConfigScreen.import')}</span>
                            </span>
                        </Button>
                        <Button outline color="primary" onClick={this.toggle}>{i18n.t('common:buttons.cancel')}</Button>
                    </ModalFooter>
                </AvForm>
            </Modal>
        );
    }
}

export default connect(null, { importMenuFromCSV })(ImportMenuFromCSVScreen);

let styles = {
    modalContainer: {
        backgroundColor: '#f8f8f8',
        paddingTop: 10,
        paddingBottom: 10,
        border: '1px solid #E9ECEF'
    },
    chooseFileInput: {
        paddingTop: 'calc(0.375rem + 1px)',
        paddingBottom: 'calc(0.375rem + 1px)',
        lineHeight: 1.5
    },
    importBtnTxt: {
        marginLeft: 6
    }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/ImportMenuFromCSVScreen.js